<template>
    <div class="v-about">
      <sub-banner id="id_about">
        <img src="../../assets/images/about/p1.jpg"/>
        <div slot="title">
          {{$t('AboutText.p1_title')}}
        </div>
        <a href="/" slot="action">{{$t('AboutText.p1_action')}}</a>
      </sub-banner>
      <p2-company-info id="id_company_info"></p2-company-info>
      <div class="separate">
        <div class="separate-1"></div>
        <div class="separate-2"></div>
        <div class="separate-3"></div>
      </div>
      <p3-team id="id_team"></p3-team>
      <p4-mission></p4-mission>
      <p5-culture></p5-culture>
    </div>
</template>

<script>
  import SubBanner from "@/components/sub-banner";
  import P2CompanyInfo from "./p2-company-info";
  import P3Team from "./p3-team";
  import P4Mission from "./p4-mission";
  import P5Culture from "./p5-culture";
    export default {
        name: "about",
      components: {P5Culture, P4Mission, P3Team, SubBanner, P2CompanyInfo},
      mounted() {
          let to = this.$route.query.to;
          if (to){
            this.$nextTick(()=>{
              let top = $(`#${to}`).offset().top;
              top -= $('.navbar').height();
              //$(`html`).scrollTop(top);
              $('html,body').animate({scrollTop: top}, 500);
            })
          }
      }
    }
</script>

<style lang="scss">
  .en .v-about{
    p {
    }
  }
  .v-about{
    color: #000000;

    p {
      text-align: justify;
      font-weight: lighter;
    }
    .separate{
      display: flex;
      >div{
        height: 4.38vw;
        width: 33%;
        background-size: 100% 100%
      }
      .separate-1{
        background: url('../../assets/images/about/separate-1.jpg');
      }
      .separate-2{
        width: 34%;
        background: url('../../assets/images/about/separate-2.jpg');
      }
      .separate-3{
        background: url('../../assets/images/about/separate-3.jpg');
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/about/about.vue